/* eslint-disable import/prefer-default-export */
import Vue from 'vue';

import { sanitizeHTML } from '../../js/universal/utils';

const ALLOWED_ELEMENTS = [
  'a',
  'b',
  'br',
  'strong',
  'i',
  'em',
  'mark',
  'small',
  'del',
  'ins',
  'sub',
  'sup',
];

export const directive = (el, binding) => {
  const sanitized = sanitizeHTML(binding.value, ALLOWED_ELEMENTS);
  // eslint-disable-next-line
  el.innerHTML = sanitized;
};

Vue.directive('safe-html', directive);
